import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  CombinationFilter,
  CombinationFilterValues
} from '@shared/interfaces/combination/combination-filters/combination-filters.interface';
import { PageableCombination } from '@shared/interfaces/combination/pageable-combination.interface';
import { Page } from '@shared/interfaces/pagination/page.interface';
import { Paging } from '@shared/interfaces/pagination/paging.interface';

export const loadTableDataAndFilters = createActionGroup({
  source: '[ ADMIN_COMBINATIONS ] Table and Filters',
  events: {
    'load table and filters': props<{ options: CombinationFilter; paging: Paging }>(),
    'load table and filters success': props<{
      page: Page<PageableCombination>;
      filters: CombinationFilterValues;
    }>(),
    'cleanup table and filters': emptyProps()
  }
});

export const loadFilters = createActionGroup({
  source: '[ ADMIN_COMBINATIONS ] Filters',
  events: {
    'load filters': props<{ options: CombinationFilter; listAll?: boolean }>(),
    'load filters success': props<{ filters: CombinationFilterValues }>()
  }
});

export const loadingAction = createAction(
  '[ ADMIN_COMBINATIONS ] LOADING',
  props<{ loading?: boolean }>()
);
export const deleteCombinationAction = createAction(
  '[ ADMIN_COMBINATIONS ] DELETE_COMBINATION',
  props<{ id: string; filters: CombinationFilter }>()
);
